import { Dispatch } from "redux";
import { ApiConfig, createRequestActionTypes, createRequestThunk, FetchRequestActions, RequestThunkParameters } from "../../../..";
import { AppStateWithData } from "../../..";
import { FeedItem } from "../../../../models/Feed";
import { processFeedResponse } from "./processFeedResponse";

export const fetchFeedItemsActionTypes = createRequestActionTypes('FETCH_FEED_ITEMS')

export type FeedItemsActions = FetchRequestActions<FeedItem[]>

export const fetchFeedItems = (config: ApiConfig) => () => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<FeedItem[]> = {
        method: 'GET',
        requestActionTypes: fetchFeedItemsActionTypes,
        url: `${config.API_URL}/feed?page=0`,
        processResultBeforeDispatch: processFeedResponse(dispatch)
    }
    return createRequestThunk(thunkParams)(dispatch, getState)
}